



























































































































































































































































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import produtoService from './produto-service';
import servicoService from '../servico/servico-service';
import * as val from '../../base/validations';
import routerService from '../../base/router-service';
import { Prop } from 'vue-property-decorator';
import areaService from '../area-atual/area-service';
import licencaService from '../licenca/licenca-service';

@Component
export default class ProdutoRegistrar extends Vue {
    @Prop() produtoId: number;
    @Prop() visualizando: boolean;

    licencas: Api.App.Server.Licenca.ListarParaProduto.Dto[];
    ultimoId: number = 0;
    areaAtual: string = null;

    tipos = [
        {
            value: Api.Common.Domain.ProdutoTipoEnum.Simples,
            text: 'Simples',
        },
        {
            value: Api.Common.Domain.ProdutoTipoEnum.Recorrente,
            text: 'Recorrente',
        },
    ];

    unidadesSimples = [
        {
            value: Api.Common.Domain.ProdutoUnidadeEnum.Unidade,
            text: 'Unid',
        },
        { value: Api.Common.Domain.ProdutoUnidadeEnum.Mes, text: 'Mês' },
        { value: Api.Common.Domain.ProdutoUnidadeEnum.Guia, text: 'Guia' },
        { value: Api.Common.Domain.ProdutoUnidadeEnum.Hora, text: 'Hora' },
    ];

    classificacao = [
        { value: Api.Common.Domain.ClassificacaoEnum.PlanoPrincipalDeEmpresas, text: 'Plano principal de empresas' },
        { value: Api.Common.Domain.ClassificacaoEnum.Funcionarios, text: 'Funcionários' },
        { value: Api.Common.Domain.ClassificacaoEnum.Outros, text: 'Outros' },
    ];

    unidadesRecorrete = [
        { value: Api.Common.Domain.ProdutoUnidadeEnum.Mes, text: 'Mês' },
    ];

    obterUnidade(produtoTipo: any) {
        if (
            produtoTipo == Api.Common.Domain.ProdutoTipoEnum.Simples ||
            this.produto.tipo == Api.Common.Domain.ProdutoTipoEnum.Simples
        ) {
            return this.unidadesSimples;
        } else if (
            produtoTipo == Api.Common.Domain.ProdutoTipoEnum.Recorrente ||
            this.produto.tipo ==
            Api.Common.Domain.ProdutoTipoEnum.Recorrente
        ) {
            return this.unidadesRecorrete;
        } else {
            return [{ value: 0, text: 'Selecione um tipo' }];
        }
    }

    produto: Api.App.Server.Produto.InserirEditar.Command = null;

    servicos: any = [];

    produtos: Api.App.Server.Produto.Listar.ProdutoDto[] = [];

    async obterParaEditar() {
        let produto = await produtoService.obterParaEditar({
            id: this.produtoId,
        });
        this.produto = produto;
        this.adicionarInclusoEmBranco();
    }

    private async listarServicos() {
        let obterServicos = await servicoService.obterServicoDescricao({});
        let result = [];

        for (let item of obterServicos.itens) {
            if (item.ativo) {
                let possuiGrupo = result.some(
                    (p) => p.header == item.categoriaTitulo
                );
                if (!possuiGrupo)
                    result.push({
                        divider: true,
                        header: item.categoriaTitulo,
                    });

                result.push({
                    id: item.id,
                    text: item.descricao,
                });
            }
        }
        this.servicos = result;
    }

    obterServicoDescricao(id: number) {
        if (!this.servicos) return '';

        let servico = this.servicos.find((p) => p.id == id);
        if (servico) {
            return servico.text;
        }
    }

    obterProdutoTitulo(id: number) {
        if (!this.produtos) return '';

        let produto = this.produtos.find((p) => p.id == id);
        if (produto) {
            return produto.titulo;
        }
    }

    obterProdutoSubtitulo(id: number) {
        if (!this.produtos) return '';

        let produto = this.produtos.find((p) => p.id == id);
        if (produto) {
            return produto.subtitulo;
        }
    }

    private async listarProdutos() {
        let obterProdutos = await produtoService.listar({});
        this.produtos = obterProdutos.itens.filter(
            (p) => p.id != this.produtoId
        );
    }

    async removerIncluso(incluso: number) {
        let excluir = await this.$confirm.open({
            title: 'Excluir',
            message: 'Deseja realmente excluir ?',
        });
        if (excluir) {
            this.produto.inclusos.splice(incluso, 1);
            this.adicionarInclusoEmBranco();

            this.$snackbars.open({
                text: 'Excluído com sucesso',
                color: 'success',
            });
        }
    }

    adicionarInclusoEmBranco() {
        let possuiEmBranco = this.produto.inclusos.some((p) => !p.filhoId);
        if (!possuiEmBranco) {
            this.produto.inclusos.push({
                id: --this.ultimoId,
                filhoId: null,
                exibirNoCarrinho: true,
                quantidadeInclusa: 1,
                quantidadeMaxima: 0,
            });
        }
    }

    obterNomeProduto(item) {
        let result = item.titulo;
        if (item.subtitulo) {
            result += ` - ${item.subtitulo}`;
        }

        return result;
    }

    async obterLicencas() {
        const { itens } = await licencaService.listarParaProduto({
            produtoId: this.produtoId,
        });
        this.licencas = itens;
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();

        if (this.areaAtual == 'admin') {
            this.listarServicos();
            this.listarProdutos();
            await this.obterLicencas();

            if (this.produtoId) {
                this.obterParaEditar();
            } else {
                this.produto = {
                    id: null,
                    codigo: null,
                    classificacao: null,
                    titulo: null,
                    subtitulo: null,
                    detalhes: null,
                    observacoes: null,
                    valor: 0,
                    unidade: null,
                    tipo: null,
                    servicoIds: null,
                    inclusos: [],
                    visivel: null,
                };
                this.adicionarInclusoEmBranco();
            }
        }
    }

    get carregando() {
        return !this.produto;
    }

    async salvarproduto() {
        this.produto.inclusos.pop();
        await this.$action.processSubmit({
            action: async () => {
                if (this.produtoId) {
                    await produtoService.editar(this.produto);
                } else {
                    await produtoService.inserir(this.produto);
                }

                this.$snackbars.open({
                    text: 'Cadastro feito com sucesso!',
                    color: 'success',
                });

                await routerService.goTo('produto-listar');
            },
            form: this.$refs.form,
            rules: this.rules,
        });
        this.adicionarInclusoEmBranco();
    }

    rules = {
        $summary: [] as any[],
        codigo: [val.required, val.minLength(3), val.maxLength(50)],
        classificacao: [val.required, val.minValue(1)],
        titulo: [val.required, val.minLength(3), val.maxLength(255)],
        subtitulo: [val.minLength(3), val.maxLength(255)],
        detalhes: [val.minLength(3), val.maxLength(1000)],
        observacoes: [val.minLength(3), val.maxLength(1000)],
        tipo: [val.required, val.minValue(1)],
        valor: [val.required, val.minValue(0)],
        unidade: [val.required, val.minValue(1)],
        filhoId: [val.minValue(1)],
        quantidadeInclusa: [val.required, val.minValue(1)],
        quantidadeMaxima: [val.required, val.minValue(0)],
    };

    async voltar() {
        await routerService.goTo('produto-listar');
    }

    async cancelar() {
        let cancelado = await this.$confirm.open({
            title: 'Cancelar',
            message: 'Deseja realmente cancelar a operação ?',
        });
        if (cancelado) {
            this.$snackbars.open({
                text: 'Ação cancelada!',
                color: 'error',
            });

            await routerService.goTo('produto-listar');
        }
    }
}
